import { render } from "./PageBuilder.vue?vue&type=template&id=eb5fd086&scoped=true&lang=html"
import script from "./PageBuilder.vue?vue&type=script&lang=js"
export * from "./PageBuilder.vue?vue&type=script&lang=js"

import "./PageBuilder.vue?vue&type=style&index=0&id=eb5fd086&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-eb5fd086"

export default script